/* ============================================
   WW1991 WISHLIST SYSTEM
   ============================================ */

(function() {
  'use strict';

  var HEART_ICON = 'https://cdn.shopify.com/s/files/1/0562/3568/8069/files/Asset_5.svg?v=1772136690';

  /* ─── Storage ─── */
  var WishlistManager = {
    storageKey: 'ww1991_wishlist',

    getWishlist: function() {
      try { return JSON.parse(localStorage.getItem(this.storageKey) || '[]'); }
      catch(e) { return []; }
    },

    saveWishlist: function(list) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(list));
        this.updateCount();
        document.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { wishlist: list } }));
        return true;
      } catch(e) { return false; }
    },

    add: function(id, data) {
      var list = this.getWishlist();
      if (list.some(function(i){ return i.id === id; })) return false;
      list.push({ id: id, title: data.title||'', handle: data.handle||'',
                  image: data.image||'', price: data.price||'', url: data.url||'', addedAt: Date.now() });
      return this.saveWishlist(list);
    },

    remove: function(id) {
      return this.saveWishlist(this.getWishlist().filter(function(i){ return i.id !== id; }));
    },

    has: function(id) {
      return this.getWishlist().some(function(i){ return i.id === id; });
    },

    updateCount: function() {
      var n = this.getWishlist().length;
      document.querySelectorAll('.wishlist-count').forEach(function(el) {
        el.textContent = n;
        el.style.display = n > 0 ? 'flex' : 'none';
      });
    }
  };

  /* ─── Update wishlist nav dropdown ─── */
  function updateWishlistDropdown() {
    var body = document.getElementById('wishlist-dropdown-body');
    if (!body) return;
    var wishlist = WishlistManager.getWishlist();
    if (!wishlist.length) {
      body.innerHTML = '<p class="nav-dropdown__empty">Your wishlist is empty</p>';
      return;
    }
    var html = wishlist.slice(0, 3).map(function(item) {
      return '<div class="nav-dropdown__item">'
        + (item.image ? '<img class="nav-dropdown__item-img" src="' + item.image + '" alt="" loading="lazy">' : '<div class="nav-dropdown__item-img"></div>')
        + '<div class="nav-dropdown__item-info">'
        + '<p class="nav-dropdown__item-title">' + (item.title || '') + '</p>'
        + '<p class="nav-dropdown__item-price">' + (item.price || '') + '</p>'
        + '</div></div>';
    }).join('');
    if (wishlist.length > 3) {
      html += '<p class="nav-dropdown__empty" style="padding:0.5rem 1rem;">+' + (wishlist.length - 3) + ' more</p>';
    }
    body.innerHTML = html;
  }

  /* ─── Flash wishlist dropdown briefly after add ─── */
  function flashWishlistDropdown() {
    var dropdown = document.getElementById('wishlist-dropdown');
    if (!dropdown) return;
    dropdown.style.opacity = '1';
    dropdown.style.visibility = 'visible';
    dropdown.style.transform = 'translateY(0)';
    dropdown.style.pointerEvents = 'all';
    setTimeout(function() {
      dropdown.style.opacity = '';
      dropdown.style.visibility = '';
      dropdown.style.transform = '';
      dropdown.style.pointerEvents = '';
    }, 2500);
  }

  /* ─── Toast ─── */
  var toast = null;
  var toastTimer = null;

  function buildToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.innerHTML =
      '<div class="wishlist-toast__thumb-placeholder" id="wt-thumb-wrap">'
        + '<img src="' + HEART_ICON + '" alt="">'
      + '</div>'
      + '<div class="wishlist-toast__body">'
        + '<span class="wishlist-toast__label" id="wt-label">SAVED TO WISHLIST</span>'
        + '<span class="wishlist-toast__title" id="wt-title"></span>'
        + '<span class="wishlist-toast__sub" id="wt-sub"></span>'
      + '</div>'
      + '<div class="wishlist-toast__actions">'
        + '<a class="wishlist-toast__view" href="/pages/wishlist">VIEW WISHLIST</a>'
        + '<button class="wishlist-toast__close" id="wt-close" aria-label="Close">&#x2715;</button>'
      + '</div>';
    document.body.appendChild(toast);
    document.getElementById('wt-close').addEventListener('click', hideToast);
  }

  function showToast(data, removed) {
    buildToast();
    clearTimeout(toastTimer);
    document.getElementById('wt-label').textContent = removed ? 'REMOVED FROM WISHLIST' : 'SAVED TO WISHLIST';
    document.getElementById('wt-title').textContent = data.title || '';
    document.getElementById('wt-sub').textContent   = data.price  || '';
    var wrap = document.getElementById('wt-thumb-wrap');
    if (data.image) {
      wrap.outerHTML = '<img class="wishlist-toast__thumb" id="wt-thumb-wrap" src="' + data.image + '" alt="' + (data.title||'') + '">';
    } else {
      if (!wrap.classList.contains('wishlist-toast__thumb-placeholder')) {
        wrap.outerHTML = '<div class="wishlist-toast__thumb-placeholder" id="wt-thumb-wrap"><img src="' + HEART_ICON + '" alt=""></div>';
      }
    }
    toast.classList.remove('open');
    requestAnimationFrame(function() { requestAnimationFrame(function() { toast.classList.add('open'); }); });
    toastTimer = setTimeout(hideToast, 3200);
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove('open');
  }

  /* ─── Button state ─── */
  function setState(btn, liked) {
    btn.classList.toggle('is-liked', liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    btn.setAttribute('aria-label', liked ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function animateIcon(btn, liked) {
    var cls = liked ? 'icon-pop' : 'icon-shrink';
    btn.classList.remove('icon-pop', 'icon-shrink');
    void btn.offsetWidth;
    btn.classList.add(cls);
    setTimeout(function() { btn.classList.remove(cls); }, liked ? 450 : 350);
  }

  /* ─── Init buttons ─── */
  function initButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';
      var id = btn.dataset.productId;
      setState(btn, WishlistManager.has(id));
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var data = {
          title:  btn.dataset.productTitle  || '',
          handle: btn.dataset.productHandle || '',
          image:  btn.dataset.productImage  || '',
          price:  btn.dataset.productPrice  || '',
          url:    btn.dataset.productUrl    || ''
        };
        var wasLiked = this.classList.contains('is-liked');
        if (wasLiked) {
          WishlistManager.remove(id);
          setState(this, false);
          animateIcon(this, false);
          showToast(data, true);
        } else {
          WishlistManager.add(id, data);
          setState(this, true);
          animateIcon(this, true);
          showToast(data, false);
          /* update and flash the dropdown */
          updateWishlistDropdown();
          flashWishlistDropdown();
        }
        /* sync other buttons for same product */
        var liked = !wasLiked;
        document.querySelectorAll('.wishlist-btn[data-product-id="' + id + '"]').forEach(function(b) {
          if (b !== btn) setState(b, liked);
        });
      });
    });
  }

  /* ─── Boot ─── */
  document.addEventListener('DOMContentLoaded', function() {
    WishlistManager.updateCount();
    initButtons();
    updateWishlistDropdown();
  });

  document.addEventListener('wishlistUpdated', updateWishlistDropdown);
  document.addEventListener('shopify:section:load', initButtons);
  window.addEventListener('storage', updateWishlistDropdown);

  window.WishlistManager = WishlistManager;
  window.updateWishlistDropdown = updateWishlistDropdown;

})();
